export default __webpack_public_path__ + "static/char-49-anr-d067e845f45df10806459b91a4524d27.webp";